// Vendor
import * as React from 'react';

// Internal
import { DEFAULT_SAL_PROPS, SAL_DELAY } from '@src/config/sal';

// Images
import treeIcon from '@src/data/images/tree-icon.png';
import wasteIcon from '@src/data/images/waste-icon.png';
import waterIcon from '@src/data/images/water-icon.png';

const ResaleSolvesWaste: React.FC = () => {
  const classesIconGroup = 'grid grid-cols-3 gap-4 mb-12 md:mb-24 mt-12';
  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS} className="max-w-2xl">
        Resale Helps Solve Fashion Waste Crisis
      </h1>
      <p
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={SAL_DELAY * 1}
        className="tup-body max-w-lg mb-12"
      >
        Throwaway fashion culture is depleting natural resources and overfilling
        landfills. The single best thing we can do is consume less and reuse
        more.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="md:border-r-2 border-gray-2">
          <h2
            {...DEFAULT_SAL_PROPS}
            data-sal-delay={SAL_DELAY * 2}
            className="text-center"
          >
            Fashion is one of the most pollutive industries in the world.
          </h2>
          <div
            {...DEFAULT_SAL_PROPS}
            data-sal-delay={SAL_DELAY * 3}
            className="text-center mt-12 mb-12"
          >
            <p className="tup-number font-bold">75 lbs</p>
            <p>
              of CO2e to produce the average
              <br />
              pair of jeans.
            </p>
          </div>
          <div
            {...DEFAULT_SAL_PROPS}
            data-sal-delay={SAL_DELAY * 4}
            className="text-center mt-12 mb-12"
          >
            <p className="text-4xl text-cleanout-light font-bold">
              700 gallons
            </p>
            <p>of water to make one new T-shirt.</p>
          </div>
          <div
            {...DEFAULT_SAL_PROPS}
            data-sal-delay={SAL_DELAY * 5}
            className="text-center mt-12 mb-12 m-auto"
            style={{ maxWidth: 250 }}
          >
            <p className="text-4xl font-bold">1 in 2</p>
            <p>
              people are throwing their unwanted clothes straight in the trash.
              The result? <b>64%</b> of the <b>32B</b> garments produced each
              year end up in landfill.
            </p>
          </div>
        </div>
        <div>
          <h2
            {...DEFAULT_SAL_PROPS}
            data-sal-delay={SAL_DELAY * 3}
            className="text-center max-w-md m-auto"
          >
            If everyone bought one item used instead of new this year, it would
            save:
          </h2>
          <div className="m-auto" style={{ maxWidth: 280 }}>
            <div
              {...DEFAULT_SAL_PROPS}
              data-sal-delay={SAL_DELAY * 4}
              className={classesIconGroup}
            >
              <img alt="Tree Icon" className="m-auto" src={treeIcon} />
              <p className="col-span-2 mt-auto mb-auto">
                <strong>5.7B lbs of CO2e</strong>
                <br /> = 66M trees planted
              </p>
            </div>
            <div
              {...DEFAULT_SAL_PROPS}
              data-sal-delay={SAL_DELAY * 5}
              className={classesIconGroup}
            >
              <img
                alt="Water Droplets Icon"
                className="m-auto"
                src={waterIcon}
              />
              <p className="col-span-2 mt-auto mb-auto">
                <strong>25B gallons of water </strong>
                <br />= 1.25B showers
              </p>
            </div>
            <div
              {...DEFAULT_SAL_PROPS}
              data-sal-delay={SAL_DELAY * 6}
              className={classesIconGroup}
            >
              <img alt="Trash Icon" className="m-auto" src={wasteIcon} />
              <p className="col-span-2 mt-auto mb-auto">
                <strong>449M lbs of waste</strong>
                <br />= 18,700 garbage trucks full
              </p>
            </div>
          </div>
        </div>
      </div>
      <p
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={SAL_DELAY * 6}
        className="tup-source text-center mt-8"
      >
        Green Story Inc. Environmental Study <sup>6</sup>
      </p>
    </div>
  );
};

export { ResaleSolvesWaste };
